export default __webpack_public_path__ + "static/media/042C5405-ADC9-49C4-967A-01F8CD0ED7B1_1_105_c.f391bb73.jpeg";